import { useCopilotInstruction as e } from "./global-state.js";
import { Renderer as t } from "../node_modules/.pnpm/@openuidev_react-lang@0.1.5_react@19.2.6/node_modules/@openuidev/react-lang/dist/Renderer.js";
import "../node_modules/.pnpm/@openuidev_react-lang@0.1.5_react@19.2.6/node_modules/@openuidev/react-lang/dist/index.js";
import { Qs as n, tt as r } from "../node_modules/.pnpm/streamdown@2.5.0_react-dom@19.2.6_react@19.2.6__react@19.2.6/node_modules/streamdown/dist/chunk-BO2N2NFS.js";
import "../node_modules/.pnpm/streamdown@2.5.0_react-dom@19.2.6_react@19.2.6__react@19.2.6/node_modules/streamdown/dist/index.js";
import { f as i } from "../node_modules/.pnpm/@streamdown_mermaid@1.0.2_react@19.2.6/node_modules/@streamdown/mermaid/dist/index.js";
import { createContext as a, useContext as o, useEffect as s, useMemo as c, useRef as l, useState as u } from "react";
import { Fragment as d, jsx as f, jsxs as p } from "react/jsx-runtime";
//#region src/react/markdown.tsx
var m = a(null), h = a(null), g = a(null);
function _({ children: t, markdown: n, library: r, libraryPromptOptions: i, approvalComponent: a, mermaidComponent: o }) {
	let s = c(() => {
		let { pre: e, code: t, ...i } = n ?? {}, a = { ...i }, o = e ?? C;
		a.pre = function({ children: e, ...t }) {
			let n = e?.props?.className ?? "";
			return n === "language-openui" || n === "language-mermaid" ? /* @__PURE__ */ f(d, { children: e }) : /* @__PURE__ */ f(o, {
				...t,
				children: e
			});
		};
		let s = t ?? w;
		return a.code = function({ className: e, children: t, ...n }) {
			let i = typeof e == "string" ? e.replace("language-", "") : "", a = typeof t == "string" ? t : String(t ?? "");
			return i === "openui" && r != null ? /* @__PURE__ */ f(v, { code: a }) : i === "mermaid" ? /* @__PURE__ */ f(b, { code: a.replace(/\n$/, "") }) : /* @__PURE__ */ f(s, {
				...n,
				className: e,
				children: t
			});
		}, a;
	}, [n, r]);
	e({ instruction: c(() => {
		let e = r == null ? null : r.prompt({
			...i,
			preamble: "When rendering UI, emit an `openui` code fence. Inside the fence, write valid openui-lang. Everything outside the fence is regular markdown."
		});
		return [
			"## Content Guidelines",
			"",
			"1. You have access to github flavored markdown. Lean on it to make your responses more readable and engaging.",
			"2. You can render diagrams using a `mermaid` code fence. Use this when visualizing flows, sequences, state machines, or relationships would help the user understand something better than prose alone. The diagram will be rendered interactively in the UI.",
			...e == null ? [] : [
				"3. You can also render rich UI components inline using an `openui` code fence. When you do, the fence content must be valid openui-lang — all syntax rules, component signatures, and streaming guidelines below apply to what goes inside the fence. Your prose outside the fence should remain standard markdown.",
				"",
				e
			]
		].join("\n");
	}, [r, i]) });
	let l = c(() => ({ components: s }), [s]);
	return /* @__PURE__ */ f(m.Provider, {
		value: l,
		children: /* @__PURE__ */ f(h.Provider, {
			value: a ?? null,
			children: /* @__PURE__ */ f(g.Provider, {
				value: r ?? null,
				children: /* @__PURE__ */ f(y.Provider, {
					value: o ?? null,
					children: t
				})
			})
		})
	});
}
function v({ code: e }) {
	let n = o(g), i = r();
	return n == null || e.trim() === "" ? null : /* @__PURE__ */ f(t, {
		response: e.trim(),
		library: n,
		isStreaming: i
	});
}
var y = a(null);
function b({ code: e }) {
	let t = r(), [n, a] = u({ status: "idle" }), c = o(y), d = l(0);
	return s(() => {
		if (t) return;
		let n = !1, r = `mermaid-${++d.current}-${Date.now()}`;
		async function o() {
			try {
				let { svg: t } = await i.getMermaid().render(r, e);
				n || a({
					status: "ok",
					svg: t,
					code: e
				});
			} catch (t) {
				n || a({
					status: "error",
					message: t instanceof Error ? t.message : "Failed to render diagram",
					code: e
				});
			}
		}
		return o(), () => {
			n = !0;
		};
	}, [e, t]), c == null ? n.status === "error" ? /* @__PURE__ */ p("pre", {
		style: {
			color: "red",
			fontSize: "0.85em"
		},
		children: ["Mermaid Error: ", n.message]
	}) : n.status === "ok" ? /* @__PURE__ */ f("div", { dangerouslySetInnerHTML: { __html: n.svg } }) : null : /* @__PURE__ */ f(c, { result: n });
}
function x() {
	return o(h);
}
function S({ children: e, isAnimating: t = !1, animated: r, rehypePlugins: i }) {
	let a = o(m);
	if (a == null) throw Error("Markdown must be used within CopilotProvider");
	return /* @__PURE__ */ f(n, {
		components: a.components,
		animated: r,
		isAnimating: t,
		rehypePlugins: i,
		children: e
	});
}
function C(e) {
	return /* @__PURE__ */ f("pre", { ...e });
}
function w(e) {
	return /* @__PURE__ */ f("code", { ...e });
}
//#endregion
export { _ as CopilotProvider, S as Markdown, x as useCopilotApproval };
